export { default as VictoryCandlestick } from "./victory-candlestick";
export { default as Candle } from "./candle";


//////////////////
// WEBPACK FOOTER
// ./~/victory-candlestick/es/index.js
// module id = 2450
// module chunks = 0